<template>
  <WindowModal :open-modal="isModalOpen" @click.self="close">
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </WindowModal>
</template>

<script>
// Utilities
import { missClicked } from 'Utils'
// Components
import WindowModal from 'Components/WindowModal'

export default {
  name: 'RouterModal',

  components: {
    WindowModal,
  },

  computed: {
    isModalOpen() {
      if (this.$store.state.modal.path) {
        return this.$route.name === this.$store.state.modal.path.name
      } else {
        return false
      }
    },
  },

  methods: {
    close() {
      // checking for a click while selectig text
      if (missClicked()) return
      this.$store.dispatch('modal/close')
    },
  },
}
</script>

<style scoped>
@media (max-width: 680px) {
  .window-modal >>> .window-modal__wrapper {
    margin: 0;
    padding-bottom: 30px;
  }
}
</style>
